import store from '../store';
import Request from './request'
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';

async function fetch(data){
    return Request("get","api/shop-profit/",data)
}

async function fetchOne(data){
    return Request('get',"api/shop-profit/view/",data)
}

// index 导出
async function exports(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/shop-profit/export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

// index 明细导出
async function download(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/shop-profit/shop-profit-detail-batch-exprot",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

// detail 导出  shop-profit/export-detail
async function exportOne(id,data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/shop-profit/export-detail/" + id,data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

export default {
    fetch,
    exports,
    download,
    fetchOne,
    exportOne
}